/*eslint-disable */

import 'fullpage-vue/src/fullpage.css'

import Register from '@/view/authentication/register/';
import Vue from 'vue';
import VueFullpage from 'fullpage-vue'
import { bus } from '@/main';
import covidPopup from '@/components/public/common/covid-19-popup';
import lbilLinkagePopup from '@/components/public/lbil-linkage-blurb-popup';
import mainLoginFormPopup from '@/components/authentication/main-login-form-popup/';
import ourPastEventScreen from '@/components/public/our-past-event-screen/';
import pahsBannerInfo from '@/components/public/pahs-banner-info/';
import projectCollaborationList from '@/components/public/project-collaboration-list/';
import random_img from '@/assets/images/lange_crub.jpg';
import random_img1 from '@/assets/images/random_img/lange_crub_1.jpg';
import random_img2 from '@/assets/images/random_img/lange_crub_2.jpg';
import random_img3 from '@/assets/images/random_img/lange_crub_3.jpg';
import random_img4 from '@/assets/images/random_img/lange_crub_4.jpg';
import random_img5 from '@/assets/images/random_img/lange_crub_5.jpg';
import requestForDemoPopup from '@/components/public/request-for-demo-popup/';
import resendOtpPopup from '@/components/authentication/resend-otp-popup/';
import vistaLinkageScreen from '@/components/public/vista-linkage-screen/';
import welcomeAudioPlay from '@/assets/audio/welcome-msg/welcome-audio.mp3';

// import conferenceInfo from '@/components/conference-info-popup';
const $ = window.jQuery = require('jquery');
// Multi Color Bg Img Of Section
var randomImgLoaded;
var randomImgSlide;
Vue.use(VueFullpage);
export default {
  name: 'home-landing-main-page',
  components: {
    'covid-popup': covidPopup,
    'sign-up': Register,
    'lbil-linkage-info' : lbilLinkagePopup,
    'resend-otp': resendOtpPopup,
    'request-for-demo-popup' : requestForDemoPopup,
    'vista-linkage-screen' : vistaLinkageScreen,
    'main-login-form-popup' : mainLoginFormPopup,
    'our-past-event-screen' : ourPastEventScreen,
    'pahs-banner-info' : pahsBannerInfo,
    'project-collaboration-list' : projectCollaborationList
  },
  props: [],
  data() {
    return {
      accordian: [{
          id: 1,
          title: 'AI and Data Laboratory on the cloud for Doctors and Researchers',
          description: ['Standardized cloud-based Data Warehousing (clinical, radiological, pathological,cytological, molecular, etc.)',
            'On demand cloud-based data Sharing', 'Off-the-shelf ML models and engines (cloud)', 'Customization of AI and ML tasks (cloud)',
            'Federated ML', 'Smart Clinical Assistant (AI powered chatbot)', 'ML Software (local systems)',
            'AI Lab'
          ],
          status: false,
          icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m24 5c0-2.757-2.243-5-5-5h-14c-2.757 0-5 2.243-5 5 0 1.734.889 3.263 2.234 4.16-.597.504-.984 1.249-.984 2.09v1.899c-.732.297-1.25 1.013-1.25 1.851v2.25c0 .414.336.75.75.75s.75-.336.75-.75v-2.25c0-.276.224-.5.5-.5s.5.224.5.5v2.25c0 .414.336.75.75.75s.75-.336.75-.75v-2.25c0-.838-.518-1.554-1.25-1.851v-1.899c0-.689.561-1.25 1.25-1.25h16c.689 0 1.25.561 1.25 1.25v1.899c-.732.297-1.25 1.013-1.25 1.851v2.25c0 .414.336.75.75.75s.75-.336.75-.75v-2.25c0-.276.224-.5.5-.5s.5.224.5.5v2.25c0 .414.336.75.75.75s.75-.336.75-.75v-2.25c0-.838-.518-1.554-1.25-1.851v-1.899c0-.841-.387-1.586-.984-2.09 1.345-.897 2.234-2.426 2.234-4.16zm-8-2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm-8 0c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z" fill="#ffc107" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m6.75 12c-.414 0-.75.336-.75.75v5.25c0 3.309 2.691 6 6 6s6-2.691 6-6v-5.25c0-.414-.336-.75-.75-.75h-4.25v5c0 .552-.448 1-1 1s-1-.448-1-1v-5z" fill="#ffc107" data-original="#000000" style="" class=""/></g></svg>`,
        },
        {
          id: 2,
          title: 'Online, Remote Medical Workspace for Doctors and Medical Researchers',
          description: [
            ' Remote Video Conferencing', ' Individual and Group/Team chats', 'File storage and sharing, Notes, Scheduler, etc. ',
            'Inter and Intra-company (hospitals/labs) Collaborative clinical & research work', ' Collaborative e-ICU (remote Intensive Care Unit) ',
            'Collaborative e-OT (remote Operation Theatre)', 'AR and VR based collaborative workspace'
          ],
          icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="34" height="34" x="0" y="0" viewBox="0 0 64 64" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m10 32c0 .01.001.021.001.031.025 3.557 4.386 6.748 10.757 8.515-.49-2.644-.758-5.521-.758-8.546 0-3.026.268-5.902.758-8.546-6.371 1.768-10.733 4.959-10.757 8.517 0 .009-.001.019-.001.029z" fill="#ffc107" data-original="#000000" style=""/><path d="m10.739 26.349c2.321-2.22 5.988-4.009 10.496-5.115 1.107-4.509 2.896-8.175 5.116-10.496-7.598 2.02-13.591 8.013-15.612 15.611z" fill="#ffc107" data-original="#000000" style=""/><path d="m32.001 10c-.001 0-.001 0-.001 0-3.569 0-6.773 4.369-8.546 10.758 2.644-.49 5.52-.758 8.545-.758 3.026 0 5.902.268 8.546.758-1.772-6.389-4.976-10.758-8.544-10.758z" fill="#ffc107" data-original="#000000" style=""/><path d="m22.927 22.926c-.592 2.784-.927 5.86-.927 9.074s.335 6.29.927 9.074c2.784.591 5.86.926 9.073.926s6.289-.335 9.072-.927c.592-2.784.927-5.86.927-9.074 0-3.213-.335-6.289-.927-9.073-2.784-.592-5.86-.926-9.073-.926s-6.289.334-9.072.926z" fill="#ffc107" data-original="#000000" style=""/><path d="m53.259 26.348c-2.021-7.597-8.014-13.589-15.61-15.61 2.22 2.321 4.009 5.987 5.116 10.496 4.507 1.106 8.173 2.895 10.494 5.114z" fill="#ffc107" data-original="#000000" style=""/><path d="m26.351 53.26c-2.22-2.32-4.009-5.986-5.116-10.494-4.508-1.106-8.175-2.895-10.496-5.115 2.021 7.596 8.014 13.589 15.612 15.609z" fill="#ffc107" data-original="#000000" style=""/><path d="m53.998 32c0-.02-.001-.04-.002-.06-.049-3.545-4.402-6.723-10.755-8.486.489 2.644.758 5.52.758 8.546s-.268 5.902-.758 8.546c6.353-1.763 10.707-4.941 10.756-8.486 0-.021.001-.04.001-.06z" fill="#ffc107" data-original="#000000" style=""/><path d="m32 53.998h.001c3.568-.001 6.771-4.369 8.544-10.756-2.644.49-5.52.758-8.545.758-3.026 0-5.901-.268-8.546-.758 1.773 6.387 4.977 10.756 8.546 10.756z" fill="#ffc107" data-original="#000000" style=""/><path d="m55.973 33c-.527 12.77-11.075 22.997-23.972 22.998h-.001s0 0-.001 0c-12.898 0-23.447-10.228-23.974-22.998h-5.026v2.999h2.469c.481 0 .895.344.983.816.665 3.552 2.037 6.864 4.077 9.845.271.397.222.932-.118 1.272l-1.745 1.745 5.656 5.656 1.745-1.745c.34-.34.874-.39 1.272-.118 2.98 2.04 6.293 3.412 9.845 4.077.473.089.815.502.815.983v2.469h8.002v-2.469c0-.481.343-.895.815-.983 3.551-.665 6.863-2.037 9.845-4.077.4-.271.934-.222 1.272.119l1.744 1.744 5.656-5.656-1.745-1.745c-.34-.341-.39-.875-.118-1.272 2.04-2.98 3.412-6.293 4.077-9.845.089-.473.502-.816.982-.816h2.472v-2.999z" fill="#ffc107" data-original="#000000" style=""/><path d="m53.259 37.651c-2.321 2.22-5.987 4.008-10.495 5.114-1.106 4.507-2.895 8.173-5.115 10.494 7.596-2.021 13.588-8.012 15.61-15.608z" fill="#ffc107" data-original="#000000" style=""/><path d="m5.023 31c.239-6.523 2.807-12.458 6.889-17.008.03 0 .058.008.088.008 1.105 0 2-.895 2-2 0-.032-.008-.061-.009-.092 4.388-3.939 10.067-6.462 16.318-6.85.353.564.976.942 1.691.942s1.338-.378 1.691-.942c6.251.389 11.93 2.913 16.318 6.852-.001.03-.009.059-.009.09 0 1.105.895 2 2 2 .029 0 .057-.007.086-.009 4.081 4.551 6.65 10.485 6.889 17.008h2c-.236-6.924-2.914-13.235-7.193-18.109.135-.269.218-.568.218-.89 0-1.105-.895-2-2-2-.319 0-.617.082-.885.215-4.695-4.128-10.731-6.76-17.361-7.158-.338-.626-.992-1.057-1.754-1.057s-1.416.431-1.754 1.057c-6.631.398-12.668 3.029-17.363 7.157-.267-.133-.564-.214-.883-.214-1.105 0-2 .895-2 2 0 .321.083.62.217.889-4.279 4.874-6.957 11.186-7.194 18.111z" fill="#ffc107" data-original="#000000" style=""/></g></g></svg>`,
          status: false
        },
        {
          id: 3,
          title: 'Online Medical Network for Doctors, Oncologists, Cancer Biologists, Biochemists, Nuclear Medicine Physicians, Medical Physicists, Medical Researchers and Other Healthcare Professionals',
          description: [
            ' Connection, Communication, Collaboration and Sharing of Knowledge based on clinical and surgical areas of expertise, research project requirements, clinical trials, etc. with algorithm based dynamic linkages within the professional network. '
          ],
          icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m456.833 401.667c-9.77 0-18.947 2.563-26.914 7.037l-62.376-62.378c-6.314 7.787-13.426 14.899-21.213 21.213l62.375 62.377c-4.474 7.968-7.038 17.146-7.038 26.917 0 30.419 24.747 55.167 55.166 55.167s55.167-24.748 55.167-55.167-24.748-55.166-55.167-55.166z" fill="#ffc107" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m55.167 110.333c9.769 0 18.947-2.563 26.914-7.037l62.376 62.378c6.314-7.787 13.426-14.899 21.213-21.213l-62.375-62.377c4.474-7.968 7.038-17.146 7.038-26.917 0-30.419-24.747-55.167-55.166-55.167s-55.167 24.748-55.167 55.167 24.748 55.166 55.167 55.166z" fill="#ffc107" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m367.542 165.674 34.62-34.622c11.133 7.209 24.383 11.415 38.605 11.415 39.278 0 71.233-31.955 71.233-71.233s-31.955-71.234-71.233-71.234-71.233 31.955-71.233 71.233c0 14.222 4.206 27.473 11.416 38.605l-34.62 34.622c7.786 6.314 14.898 13.426 21.212 21.214z" fill="#ffc107" data-original="#000000" style="" class=""/><circle xmlns="http://www.w3.org/2000/svg" cx="256" cy="239.934" r="33.2" fill="#ffc107" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m256.016 303.134c-40.736 0-58.453 32.152-62.83 47.391 18.001 12.002 39.604 19.008 62.814 19.008s44.813-7.007 62.814-19.008c-4.341-15.118-21.92-47.391-62.798-47.391z" fill="#ffc107" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m256 142.467c-62.603 0-113.533 50.931-113.533 113.533 0 27.823 10.066 53.334 26.739 73.1 4.112-9.057 15.57-30.693 41.863-44.773-11.286-11.422-18.269-27.105-18.269-44.393 0-34.849 28.352-63.2 63.2-63.2s63.2 28.352 63.2 63.2c0 17.288-6.983 32.971-18.27 44.394 26.301 14.082 37.756 35.727 41.864 44.772 16.673-19.765 26.739-45.277 26.739-73.1 0-62.603-50.93-113.533-113.533-113.533z" fill="#ffc107" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m144.458 346.326-34.621 34.622c-11.132-7.209-24.382-11.415-38.604-11.415-39.278 0-71.233 31.955-71.233 71.234s31.955 71.233 71.233 71.233 71.233-31.955 71.233-71.233c0-14.223-4.206-27.474-11.416-38.606l34.62-34.621c-7.787-6.315-14.898-13.427-21.212-21.214z" fill="#ffc107" data-original="#000000" style="" class=""/></g></svg>`,
          status: false
        },
        {
          id: 4,
          title: 'Virtual Precision Medicine Centre and Drug Discovery Lab',
          description: [' Hospital and Doctor (global) search via aggregation',
            ' Hospital registration and remote treatment',
            ' Telemedicine',
            ' Data upload and drop box',
            ' Centralized diagnostic link',
            ' Direct linkages with Diagnostic labs',
            ' Patient education'
          ],
          icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="34" height="34" x="0" y="0" viewBox="0 0 480 480" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m240 58c-4.418 0-8-3.582-8-8v-42c0-4.418 3.582-8 8-8s8 3.582 8 8v42c0 4.418-3.582 8-8 8zm-72-8v-42c0-4.418-3.582-8-8-8s-8 3.582-8 8v42c0 4.418 3.582 8 8 8s8-3.582 8-8zm160 0v-42c0-4.418-3.582-8-8-8s-8 3.582-8 8v42c0 4.418 3.582 8 8 8s8-3.582 8-8zm-80 422v-42c0-4.418-3.582-8-8-8s-8 3.582-8 8v42c0 4.418 3.582 8 8 8s8-3.582 8-8zm80 0v-42c0-4.418-3.582-8-8-8s-8 3.582-8 8v42c0 4.418 3.582 8 8 8s8-3.582 8-8zm-160 0v-42c0-4.418-3.582-8-8-8s-8 3.582-8 8v42c0 4.418 3.582 8 8 8s8-3.582 8-8zm312-232c0-4.418-3.582-8-8-8h-42c-4.418 0-8 3.582-8 8s3.582 8 8 8h42c4.418 0 8-3.582 8-8zm0-80c0-4.418-3.582-8-8-8h-42c-4.418 0-8 3.582-8 8s3.582 8 8 8h42c4.418 0 8-3.582 8-8zm0 160c0-4.418-3.582-8-8-8h-42c-4.418 0-8 3.582-8 8s3.582 8 8 8h42c4.418 0 8-3.582 8-8zm-422-80c0-4.418-3.582-8-8-8h-42c-4.418 0-8 3.582-8 8s3.582 8 8 8h42c4.418 0 8-3.582 8-8zm0 80c0-4.418-3.582-8-8-8h-42c-4.418 0-8 3.582-8 8s3.582 8 8 8h42c4.418 0 8-3.582 8-8zm0-160c0-4.418-3.582-8-8-8h-42c-4.418 0-8 3.582-8 8s3.582 8 8 8h42c4.418 0 8-3.582 8-8zm340-38v236c0 22.06-17.94 40-40 40h-236c-22.06 0-40-17.94-40-40v-236c0-22.06 17.94-40 40-40h236c22.06 0 40 17.94 40 40zm-147.394 146.894c-5.861-5.862-15.349-5.865-21.212-.001-5.862 5.86-5.866 15.351-.001 21.213 5.861 5.862 15.35 5.864 21.212.001 5.864-5.861 5.865-15.349.001-21.213zm26.164-26.164c-20.321-20.322-53.215-20.325-73.539 0-3.124 3.124-3.124 8.189 0 11.313 3.125 3.125 8.189 3.124 11.314 0 14.068-14.069 36.841-14.07 50.91 0 3.124 3.124 8.189 3.124 11.314 0 3.125-3.123 3.125-8.189.001-11.313zm29.699-29.698c-36.738-36.737-96.196-36.74-132.938 0-3.124 3.124-3.124 8.189 0 11.313 3.125 3.124 8.189 3.124 11.314 0 30.481-30.483 79.824-30.487 110.309 0 3.124 3.124 8.189 3.124 11.314 0 3.125-3.123 3.125-8.189.001-11.313z" fill="#ffc107" data-original="#000000" style="" class=""/></g></svg>`,
          status: false
        },
        {
          id: 5,
          title: 'Virtual Research Platform, Research Library & Education for Medical Students and Medical Researchers',
          description: ['Collaborative clinical trials',
            'Collaborative clinical and radiological research',
            'Computational pathology and computational radiology',
            'Combination of cloud computing, computational chemistry and collaborative drug discovery',
            'Research and cloud computing for hard-to-drug targets, in silico design',
            ' Integrating with third party CDD (cloud-based drug discovery) software', ' Remote educational courses and training for med school students', ' AI & ML courses and training for doctors, researchers and medical professionals',
          ],
          icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="34" height="34" x="0" y="0" viewBox="0 0 64 64" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg" id="Research_on_virus"><g><circle cx="38.7" cy="50.8" r="1" fill="#ffc107" data-original="#000000" style="" class=""/><path d="m55.6 60h-3.3l-6.1-9.7c6-3.8 9.7-10.4 9.7-17.5 0-4.8-1.7-9.4-4.7-13.1l.5-.5c.4-.4.4-1 0-1.4l-3.4-3.4 2.1-2.1c.4-.4.4-1 0-1.4l-.7-.7 2.1-2.2c.4-.4.4-1 0-1.4l-4.4-4.4c-.3-.3-.9-.5-1.4 0l-2.1 2.2-.7-.7c-.4-.4-1-.4-1.4 0l-10.7 10.7c-1.3-1-3.3-.9-4.5.3-1.4 1.4-1.4 3.6 0 4.9l1 1-3.6 3.6c-.4.4-.4 1 0 1.4l4.4 4.4c.3.3 1 .4 1.4 0l3.6-3.6 1 1c1.5 1.5 3.7 1.2 4.9 0s1.3-3.2.3-4.5l1.6-1.6 3.4 3.4c.4.4 1.1.3 1.4 0l.8-.8c1.9 2.5 3 5.6 3 8.8 0 5-2.6 9.7-6.8 12.4l-.5-.8c-.2-.2-.5-.3-.8-.3h-9c-.6 0-1 .4-1 1v2c-4.2-1.1-7.9-4.1-9.7-8.1h1.9c.6 0 1-.4 1-1s-.4-1-1-1h-10.2c-.6 0-1 .4-1 1s.4 1 1 1h1.9c2.3 7.4 8.6 12.9 16.1 14.2v6.9h-3c-.6 0-1 .4-1 1s.4 1 1 1h26.9c.6 0 1-.4 1-1s-.5-1-1-1zm-26.5-32.1-2.9-2.9 2.9-2.9 2.9 2.9zm17.6-23.5 2.9 2.9-1.4 1.4-2.9-2.9zm-1.4 18.3-2.7-2.7 4.1-4.1 2.7 2.7zm-6.6 31.1c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" fill="#ffc107" data-original="#000000" style="" class=""/><circle cx="22.8" cy="33" r="2" fill="#ffc107" data-original="#000000" style="" class=""/><circle cx="17.8" cy="34" r="1" fill="#ffc107" data-original="#000000" style="" class=""/><path d="m20.4 24h-.9c-.1-.7-.4-1.3-.8-1.9l.7-.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-.7.7c-.6-.4-1.2-.6-1.9-.8v-.9c0-.6-.4-1-1-1s-1 .4-1 1v1c-.7.1-1.3.4-1.9.8l-.6-.7c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l.6.7c-.4.6-.6 1.2-.8 1.9h-.9c-.6 0-1 .4-1 1s.4 1 1 1h.9c.1.7.4 1.3.8 1.9l-.6.6c-.4.4-.4 1 0 1.4s1 .4 1.4 0l.6-.6c.6.4 1.2.6 1.9.8v.8c0 .6.4 1 1 1s1-.4 1-1v-.9c.7-.1 1.3-.4 1.9-.8l.7.7c.4.4 1 .4 1.4 0s.4-1 0-1.4l-.7-.7c.4-.6.6-1.2.8-1.9h.9c.6 0 1-.4 1-1 0-.5-.4-1-1-1zm-6 2.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z" fill="#ffc107" data-original="#000000" style="" class=""/></g></g></g></svg>`,
          status: false
        }
      ],
      lbilAbout: [{
          id: 'lbilAbout1',
          title: 'Digital Front Door for Patients',
          icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
        },
        {
          id: 'lbilAbout2',
          title: 'Electronic Medical Records Centre for Patients',
          icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
        },
        {
          id: 'lbilAbout3',
          title: 'Hospital and Doctor Aggregation for Patients',
          icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`
        },
        {
          id: 'lbilAbout4',
          title: 'Telemedicine and Remote Treatment for Patients',
          icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
        },
        {
          id: 'lbilAbout5',
          title: 'Virtual OPD, Virtual ICU and Virtual Operation Theatre for Doctors and Patients',
          icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
        }
      ],
      preloader: true,
      randomImg: '',
      animationImg: '',
      first_slide: true,
      second_slide: false,
      getDetailsOfLoginUser: '',
      mblLogined: false,
      signUpFormEnabled: false,
      accept_terms: '',
      accordian1: true,
      accordian2: false,
      firstTimeVisit: sessionStorage.getItem('firstTimeVisit'),
      slideStatus:false,
      opts: {
        start: 0,
        dir: 'v',
        duration: 700,
        loop:false,
        overflow:'auto',
        movingFlag:true,
        beforeChange(currentSlideEl, currenIndex, nextIndex) {
          if(nextIndex == '1'){
            $(".request_for_demo_label_fixed.default_actv").addClass('d-none');
            $('.request_for_demo_label_fixed.slide_actv').removeClass('d-none');
          }else{
            $(".request_for_demo_label_fixed.default_actv").removeClass('d-none');
            $('.request_for_demo_label_fixed.slide_actv').addClass('d-none');
          }
          if(nextIndex == '2' || nextIndex == '3' || nextIndex == '4'){
            $('.request_for_demo_label_fixed').addClass('d-none');
            $('.home_right_side_tools').addClass('d-none');
          }else{
            setTimeout(() => {
              $('.home_right_side_tools').removeClass('d-none');
            }, 150);
          }
          if(nextIndex == '0'){
            setTimeout(() => {
              $('.pahs_collaboration_info').removeClass('d-none');
            }, 150);
          }else{
            $('.pahs_collaboration_info').addClass('d-none');
          }
        },
        afterChange (currentSlideEl, currenIndex) {
          if(currenIndex == '4'){
            $('.footer_wrp').removeClass('d-none');
          }else{
            $('.footer_wrp').addClass('d-none');
          }
        },
      },
      actvSlide:false,
      lbilLinkagePopupState:false,
      mainLoginFormPopupState:false,
      authBtnShowState:true,
      authCheckLabelState:false,
    }
  },
  computed: {},
  mounted() {
    if (localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != null) {
      this.authCheckLabelState = false
    } else {
      this.authCheckLabelState = true
    }
    setTimeout(() => {
      this.actvSlide = true
    }, 800)
    this.animationImg = random_img
    var _self = this
    $(document).ready(function (argument) {
      $(document).ready(function (argument) {
        $(".lymphomap_ab_btn .btn").click(function () {
          $(window).scrollTop(0);
          $(".lymphomap_about").toggleClass("active");
          $('.covid_19_popup').toggleClass('covid_popup_disabled')
          $('.more_info_add').addClass('d-none')
        });
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".lymphomap_ab_btn .btn, .light_bg_popup").length) {
            $("body").find(".lymphomap_about").removeClass("active");
            $("body").find('.covid_19_popup').removeClass('covid_popup_disabled')
            $('.more_info_add').removeClass('d-none')
            var i;
            for (i = 0; i < _self.accordian.length; i++) {
              _self.accordian[i].status = false;
            }
            setTimeout(() => {
              $('.ab_main_popup .light_bg_popup').animate({
                scrollTop: 0
              });
              $('.ab_top_arrow').addClass('d-none')
              $('.ab_down_arrow').removeClass('d-none')
            }, 300);
          }
        });
      });
      $(document).ready(function (argument) {
        $(".lymphomap_computer_btn .btn").click(function () {
          $(window).scrollTop(0);
          $(".ai_algorithms_popup").toggleClass("active");
          $('body').addClass('covid_popup_disabled')
        });
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".lymphomap_computer_btn .btn,.light_bg_popup").length) {
            $("body").find(".ai_algorithms_popup").removeClass("active");
            $('body').removeClass('covid_popup_disabled')
            setTimeout(() => {
              $('.ai_algorithms_popup .welcome_popup_inner').animate({
                scrollTop: 0
              });
            }, 300);
          }
        });
      });
      $(document).ready(function (argument) {
        $(".cancer_classification_btn .btn").click(function () {
          $(window).scrollTop(0);
          $(".cancer_classification_popup_wrp").toggleClass("active");
          $('body').addClass('covid_popup_disabled')
        });
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".cancer_classification_btn .btn,.light_bg_popup").length) {
            $("body").find(".cancer_classification_popup_wrp").removeClass("active");
            $('body').removeClass('covid_popup_disabled')
            setTimeout(() => {
              $('.cancer_classification_popup_wrp .welcome_popup_inner').animate({
                scrollTop: 0
              });
            }, 300);
          }
        });
      });
      setTimeout(function () {
        $(".more_info_add").addClass("login_showing")
        $(".lymphomap_ab_btn").addClass("showing")
        $(".lymphomap_computer_btn").addClass("showing")
      }, 100)
      $('.three_down_arrow').on('click', function (e) {
        e.preventDefault();
        var section_height = $('.lymphomap_computer_data_inner').height()
        $('.ai_algorithms_popup .welcome_popup_inner').animate({
          scrollTop: section_height
        }, 500, 'linear');
      });
      $('.three_top_arrow').on('click', function (e) {
        e.preventDefault();
        $('.ai_algorithms_popup .welcome_popup_inner').animate({
          scrollTop: 0
        }, 500, 'linear');
      });
      $('.lymphomap_about .ab_down_arrow').on('click', function (e) {
        e.preventDefault();
        var section_height = $('.lymphomap_about .about_first_section').height()
        $('.lymphomap_about .light_bg_popup').animate({
          scrollTop: section_height
        }, 500, 'linear');
        $('.lymphomap_about .ab_down_arrow').addClass('d-none')
      });
      $('.lymphomap_about .ab_top_arrow').on('click', function (e) {
        e.preventDefault();
        $('.lymphomap_about .light_bg_popup').animate({
          scrollTop: 0
        }, 500, 'linear');
        $('.lymphomap_about .ab_top_arrow').addClass('d-none')
        $('.lymphomap_about .ab_down_arrow').removeClass('d-none')
      });
      $('.lymphomap_about .light_bg_popup').scroll(function () {
          if (80 > $('.lymphomap_about .light_bg_popup').scrollTop()) {
            $('.lymphomap_about .ab_top_arrow').addClass('d-none')
            $('.lymphomap_about .ab_down_arrow').removeClass('d-none')
          } else if (300 < $('.lymphomap_about .light_bg_popup').scrollTop() && $('.lymphomap_about .light_bg_popup').scrollTop() < 700) {
            $('.lymphomap_about .about_second_section .ab_down_for_lbil_arrow').removeClass('d-none')
            $('.lymphomap_about .ab_down_arrow').addClass('d-none')
          } else if (701 < $('.lymphomap_about .light_bg_popup').scrollTop()) {
            $('.lymphomap_about .about_lbil_third_section .ab_top_for_lbil_arrow').removeClass('d-none')
            $('.lymphomap_about .about_second_section .ab_down_for_lbil_arrow').addClass('d-none')
          }
        }),
        $('.lymphomap_about .ab_down_for_lbil_arrow').on('click', function (e) {
          e.preventDefault();
          var section_height1 = $('.lymphomap_about .about_first_section').height()
          let section_height = $('.lymphomap_about .about_second_section').height()
          $('.lymphomap_about .light_bg_popup').animate({
            scrollTop: section_height1 + section_height
          }, 500, 'linear');
          $('.lymphomap_about .about_second_section .ab_top_arrow').addClass('d-none')
          $('.lymphomap_about .about_second_section .ab_down_for_lbil_arrow').addClass('d-none')
          $('.lymphomap_about .about_lbil_third_section .ab_top_for_lbil_arrow').removeClass('d-none')
        });
      $('.lymphomap_about .ab_top_for_lbil_arrow').on('click', function (e) {
        e.preventDefault();
        var section_height1 = $('.lymphomap_about .about_lbil_third_section').height()
        let section_height = $('.lymphomap_about .about_second_section').height()
        $('.lymphomap_about .light_bg_popup').animate({
          scrollTop: section_height1
        }, 500, 'linear');
        $('.lymphomap_about .about_second_section .ab_top_arrow').removeClass('d-none')
        $('.lymphomap_about .about_second_section .ab_down_for_lbil_arrow').removeClass('d-none')
        $('.lymphomap_about .about_lbil_third_section .ab_top_for_lbil_arrow').addClass('d-none')
      });
    });
    bus.$emit('showHeaderbtn', false);
    this.randomImg = random_img
    this.randomImgSlide()
    this.randomImgLoaded()
    randomImgSlide = setInterval(() => {
      this.randomImgSlide()
    }, 20000);
    randomImgLoaded = setInterval(() => {
      this.randomImgLoaded()
    }, 21500);
    bus.$on('showSignUpForm', (data) => {
      this.signUpFormEnabled = data;
      this.opts.movingFlag = false
    });
    if(localStorage.getItem('token') === null) {
      if (this.firstTimeVisit === null) {
        this.playSound(welcomeAudioPlay)
        sessionStorage.setItem('firstTimeVisit', 'visited')
      }
    }
    bus.$on('lbilLinkagePopupStateBus', (data) => {
      this.lbilLinkagePopupState = data;
    });
    bus.$on('mainLoginFormPopupStateBus', (data) => {
      this.mainLoginFormPopupState = data;
      this.opts.movingFlag = false
      this.authBtnShowState = true
    });
    bus.$on('moveToFirstInSliderBus', (data) => {
      if(data){
        if(this.isMobile){
          this.scrollBackTopOfDemoReqMethod();
        }else{
          this.movePrev();
        }
      }
    });
    bus.$on('movingFlagStateBus', (data) => {
      this.opts.movingFlag = data
    });
    bus.$on('movingSlideStateBus', (index) => {
      this.moveToSection(index);
    });
  },
  methods: {
    scrollTopOfDemoReqMethod(){
        let scrTop = $('.login_form_section')[0].scrollHeight
        $('html, body').animate({scrollTop:scrTop - 40}, 500);
    },
    scrollBackTopOfDemoReqMethod(){
        $('html, body').animate({scrollTop:0}, 500);
    },
    moveToSection(sectionIndex) {
      this.$refs.example.$fullpage.moveTo(sectionIndex/*move to index*/, true /*animatied*/, false /*force move?*/)
    },
    moveNext(){
      this.$refs.example.$fullpage.moveNext(); //Move to the next page
    },
    movePrev(){
      this.$refs.example.$fullpage.movePrev(); //Move to the next page
    },
    loginFormShowMethod(){
      $(window).scrollTop(0);
      this.opts.movingFlag = true
      this.mainLoginFormPopupState = true
      this.authBtnShowState = false
    },
    signUpFormShow() {
      setTimeout(() => {
        bus.$emit('showSignUpForm', true);
        this.opts.movingFlag = true
        $('body').addClass('registration_form')
      }, 1)
    },
    lbilLinkagePopupOpenMethod() {
      this.lbilLinkagePopupState = true
    },
    onResize() {
      this.isMobile = window.innerWidth < 1023;
    },
    togleacordian: function (a) {
      var i;
      for (i = 0; i < this.accordian.length; i++) {
        if (i === a) {
          this.accordian[i].status = this.accordian[i].status == true ? false : true;
        } else {
          this.accordian[i].status = false;
        }
      }
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    randomImgSlide() {
      setTimeout(() => {
        $(".oncology_well_new").addClass("active")
        $(".oncology_wel_popup").removeClass("active")
        setTimeout(() => {
          $(".oncology_well_new").css('z-index', '10')
          $(".oncology_wel_popup").css('z-index', '11')
          $(".oncology_wel_line_crub").addClass("animation_play")
        }, 1505)
      }, 10000)
      setTimeout(() => {
        $(".oncology_well_new").removeClass("active")
        $(".oncology_wel_popup").addClass("active")
        setTimeout(() => {
          $(".oncology_wel_popup").css('z-index', '10')
          $(".oncology_well_new").css('z-index', '11')
          $(".oncology_wel_line_crub").removeClass("animation_play")
        }, 1500)
      }, 20000)
    },
    randomImgLoaded() {
      setTimeout(() => {
        this.randomImg = random_img1
      }, 3500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 5500)
      setTimeout(() => {
        this.randomImg = random_img2
      }, 7500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 9500)
      setTimeout(() => {
        this.randomImg = random_img3
      }, 11500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 13500)
      setTimeout(() => {
        this.randomImg = random_img4
      }, 15500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 17500)
      setTimeout(() => {
        this.randomImg = random_img5
      }, 19500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 21500)
    },
  },
  beforeCreate: function () {
    $('body').addClass('login_body')
    $('.footer_wrp').addClass('d-none');
  },
  beforeRouteLeave: function (to, from, next) {
    this.signUpFormEnabled = false
    $('body').removeClass('login_body')
    $(".sign_up_btn").removeClass("d-none")
    $('body').removeClass('registration_form')
    $('.footer_wrp').removeClass('d-none');
    clearInterval(randomImgSlide);
    clearInterval(randomImgLoaded);
    next();
  },
  created() {
    window.addEventListener('resize', this.onResize, {
      passive: true
    })
    this.onResize()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, {
        passive: true
      })
    }
  },
}